module.exports = __webpack_public_path__ + "static/media/avatar.20c74952.png";